import { Link } from 'gatsby'
import styled from 'styled-components'

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme, color }) => color ? theme.colors[color] : theme.colors.brown[300]};

  &:hover {
    text-decoration: underline;
  }
`
